export default __webpack_public_path__ + "static/media/cloud@3x.d626ddf0.svg";